import { MetadataType } from "../enums/enums"
import { QuestionData } from "../models/global.types"

export function getMcqPart(question: QuestionData): number | null {
  if (question === undefined) { return null }
  if (question.metadata === undefined || question.metadata.length === 0) { return null }

  for (const meta of question.metadata) {
    if (meta.name === MetadataType.QuestionMcqPart) {
      const value = parseInt(meta.value)
      if (isNaN(value)) { return null }
      return value
    }
  }

  return null
}

export function getVideoTimestamp(question: QuestionData): number | null {
  if (question === undefined) { return null }
  if (question.metadata === undefined || question.metadata.length === 0) { return null }
  
  for (const meta of question.metadata) {
    if (meta.name === MetadataType.QuestionVideoTimestamp) {
      const value = parseFloat(meta.value)
      if (isNaN(value)) { return null }
      return value
    }
  }

  return null
}

const newMetadata = {
  id: 'backwardsCompatibleMcqPartMetadata',
  name: MetadataType.QuestionMcqPart,
  value: '1'
}

/**
 * Checks if the question has part metadata set, and if not, sets it as part 1.
 * Done for backwards compatibility.
 */
export function ensureMcqPartMetadata(question: QuestionData): void {
  if (question.metadata === undefined) {
    question.metadata = [newMetadata]
  }
  else if (getMcqPart(question) === null) {
    question.metadata.push(newMetadata)
  }
  
}
